/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AuthorizeCliDeviceMutationVariables = Types.Exact<{
  userCode: Types.Scalars["String"]["input"];
  action: Types.CliDeviceAction;
}>;

export type AuthorizeCliDeviceMutation = {
  readonly __typename: "Mutation";
  readonly authorizeCliDevice: {
    readonly __typename: "CliDeviceAuthResult";
    readonly action: Types.CliDeviceAction;
  };
};

export const AuthorizeCliDeviceDocument = /*#__PURE__*/ gql`
  mutation AuthorizeCliDevice($userCode: String!, $action: CliDeviceAction!) {
    authorizeCliDevice(userCode: $userCode, action: $action) {
      action
    }
  }
`;
export type AuthorizeCliDeviceMutationFn = Apollo.MutationFunction<
  AuthorizeCliDeviceMutation,
  AuthorizeCliDeviceMutationVariables
>;

/**
 * __useAuthorizeCliDeviceMutation__
 *
 * To run a mutation, you first call `useAuthorizeCliDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeCliDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeCliDeviceMutation, { data, loading, error }] = useAuthorizeCliDeviceMutation({
 *   variables: {
 *      userCode: // value for 'userCode'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useAuthorizeCliDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthorizeCliDeviceMutation,
    AuthorizeCliDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthorizeCliDeviceMutation,
    AuthorizeCliDeviceMutationVariables
  >(AuthorizeCliDeviceDocument, options);
}
export type AuthorizeCliDeviceMutationHookResult = ReturnType<
  typeof useAuthorizeCliDeviceMutation
>;
export type AuthorizeCliDeviceMutationResult =
  Apollo.MutationResult<AuthorizeCliDeviceMutation>;
export type AuthorizeCliDeviceMutationOptions = Apollo.BaseMutationOptions<
  AuthorizeCliDeviceMutation,
  AuthorizeCliDeviceMutationVariables
>;
